<template>
    <div id="tst">
      <span v-if="component.name.toLowerCase().indexOf('nfe') != -1"><btnNFe :nota="nota"></btnNFe></span>
      <span v-if="component.name == 'CTE'" ><btnCTe :nota="nota"></btnCTe></span>
      <span v-if="component.name == 'NFSE'" ><btnNFSe :nota="nota"></btnNFSe></span>
      <span v-if="component.name == 'Iptu'" ><btnIptu :nota="nota"></btnIptu></span>
    </div>

</template>
<script>
import NfeService from "@/domain/notas/nfe/NfeService";
import btnNFe from "./btnNFe/BtnNFe";
import btnCTe from "./btnCTe/BtnCTe";
import btnCce from "./btnCce/BtnCce";
import btnNFSe from "./btnNfse/BtnNFSe";
import btnIptu from "./btnIptu/BtnIptu.vue"
//  v-if="(nota.item.xmlCce.length > 0)"
export default {
  props: ["nota", "component"],
  components: {
    btnNFe: btnNFe,
    btnCce: btnCce,
    btnCTe: btnCTe,
    btnNFSe:btnNFSe,
    btnIptu:btnIptu
  },
  data() {
    return {
      menu: false,
      dialog: false,
      danfeB64: "",
      dacceB64: "",
      items: [
        {
          id: "danfe",
          title: "Nota Fiscal - DANFE",
          mostrar: true,
          content: null
        },
        {
          id: "cce",
          title: "Carta de correção - Cce ",
          mostrar: true,
          quantidade: 0,
          content: null
        }
      ],
      modal: { id: "", text: "", content: "", info: "" }
    };
  },
  watch: {},
  computed: {},
  mounted: function() {
    this.$nextTick(function() {
      if (this.component.name.indexOf("NFe") != -1) {
        let cce = null;
        let qntidade_cce = this.nota.item.xmlCce ? this.nota.item.xmlCce.length : 0;
        qntidade_cce > 0 ? (cce = true) : (cce = false);
        this.items.forEach(function(item) {
          item.id == "cce"
            ? ((item.mostrar = cce), (item.quantidade = qntidade_cce))
            : null;
        });
      }
    });
  },
  methods: {
    getDanfe: async function(id, item) {
      this.danfeB64 = "";
      this.menu = true;
      if (!this.nota.item.danfe) {
        this.service = new NfeService(this.$http);
        await this.service.getDanfe(id).then(function(danfe) {
          this.nota.item.danfe = danfe;
          this.danfeB64 = danfe;
        });
      }
      this.open(item);
    },
    getCce: async function(id, indice) {
      this.service = new NfeService(this.$http);
      await this.service.getDacce(id, indice).then(function(dacce) {
        this.modal.content = dacce;
      });
    },
    open: function(item) {
      this.modal.content = "";

      this.modal.text = item.title;
      this.modal.id = item.id;
      item.id == "danfe"
        ? ((this.modal.content = this.danfeB64), (this.modal.info = ""))
        : (this.modal.info = "Selecione uma Cce para visualizar");
      this.dialog = true;
    }
  }
};
</script>
<style>
#tst {
  display: inline-block;
}
#options {
  cursor: pointer;
}
.item:after {
  content: "";
  position: absolute;
  transition: all 0.5s linear;
  height: 2px;
  background-color: #25476a;
  width: 0%;
}
.item {
  transition: all 0.8s ease-in-out;
}
.item:hover {
  background-color: #eaeaea;
}
.item:hover:after {
  width: 100%;
  background-color: orangered;
}
#title {
  cursor: default;
  text-align: center;
  text-transform: uppercase;
  font-weight: 800;
  padding: 6px;
  font-family: "Quicksand", sans-serif;
  color: #25476a;
}
#lista {
  padding: 20px;
}

#ico.v-btn {
  margin: 2px 2px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnVisualizar/BtnVisualizar.vue